import React from 'react';

const CoinDetailsSkeleton = () => {
  return (
    <div className="">
      <main className="content-area">
        <div className="wallet-dashboard">
          <div className="grid lg:grid-cols-[450px_1fr] grid-cols-1 gap-[20px] mb-3">
            {/* Left Sidebar Skeleton */}
            <div className="lg:sticky top-10">
              {/* WalletDashboardCard Skeleton */}
              <div className="card p-4 mb-4">
                <div className="skeleton" style={{ height: '200px', borderRadius: '8px' }}></div>
              </div>

              {/* Protocol Info Skeleton */}
              <div className="alert bg-light border">
                <div className="skeleton mb-3" style={{ height: '24px', width: '60%' }}></div>
                <div className="skeleton mb-2" style={{ height: '16px', width: '100%' }}></div>
                <div className="skeleton mb-2" style={{ height: '16px', width: '95%' }}></div>
                <div className="skeleton mb-2" style={{ height: '16px', width: '90%' }}></div>
                <div className="skeleton" style={{ height: '16px', width: '85%' }}></div>
              </div>
            </div>

            {/* Main Content Skeleton */}
            <div>
              {/* Header Skeleton */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="d-flex gap-3 align-items-center">
                  <div className="skeleton rounded-circle" style={{ width: '40px', height: '40px' }}></div>
                  <div>
                    <div className="skeleton mb-2" style={{ height: '24px', width: '150px' }}></div>
                    <div className="skeleton" style={{ height: '16px', width: '100px' }}></div>
                  </div>
                </div>

                <div className="text-end flex gap-3">
                  <div>
                    <div className="skeleton mb-2" style={{ height: '32px', width: '120px' }}></div>
                    <div className="skeleton" style={{ height: '16px', width: '80px' }}></div>
                  </div>
                  <div className="skeleton" style={{ width: '40px', height: '40px', borderRadius: '8px' }}></div>
                </div>
              </div>

              {/* Stats Skeleton */}
              <div className="row mb-4">
                <div className="col-md-6 mb-md-0 mb-3">
                  <div className="card p-3">
                    <div className="skeleton mb-2" style={{ height: '16px', width: '80px' }}></div>
                    <div className="skeleton" style={{ height: '24px', width: '120px' }}></div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card p-3">
                    <div className="skeleton mb-2" style={{ height: '16px', width: '80px' }}></div>
                    <div className="skeleton" style={{ height: '24px', width: '120px' }}></div>
                  </div>
                </div>
              </div>

              {/* Chart Skeleton */}
              <div className="card">
                <div className="mb-2 d-flex gap-2 justify-end p-3">
                  {[1, 2, 3, 4].map(i => (
                    <div key={i} className="skeleton" style={{ width: '40px', height: '32px', borderRadius: '4px' }}></div>
                  ))}
                </div>
                <div className="skeleton" style={{ height: '260px', margin: '0 16px 16px 16px', borderRadius: '8px' }}></div>
              </div>

              {/* Action Buttons Skeleton */}
              <div className="d-flex gap-2 w-100 mt-4 mb-2">
                <div className="skeleton" style={{ height: '40px', flex: 1, borderRadius: '8px' }}></div>
                <div className="skeleton" style={{ height: '40px', flex: 1, borderRadius: '8px' }}></div>
              </div>
              <div className="skeleton w-full mt-2" style={{ height: '40px', borderRadius: '8px' }}></div>

              {/* Transaction History Skeleton */}
              <div className="card shadow-sm my-4">
                <div className="card-header py-4 bg-white">
                  <div className="skeleton" style={{ height: '20px', width: '150px' }}></div>
                </div>

                <div className="table-responsive">
                  <table className="table table-hover align-middle mb-0">
                    <thead className="table-light text-sm">
                      <tr>
                        <th className="px-3 py-2"><div className="skeleton" style={{ height: '16px', width: '40px' }}></div></th>
                        <th className="px-3 py-2"><div className="skeleton" style={{ height: '16px', width: '60px' }}></div></th>
                        <th className="px-3 py-2"><div className="skeleton" style={{ height: '16px', width: '60px' }}></div></th>
                        <th className="px-3 py-2"><div className="skeleton" style={{ height: '16px', width: '40px' }}></div></th>
                        <th className="px-3 py-2"><div className="skeleton" style={{ height: '16px', width: '40px' }}></div></th>
                        <th className="px-3 py-2"><div className="skeleton" style={{ height: '16px', width: '50px' }}></div></th>
                      </tr>
                    </thead>
                    <tbody>
                      {[1, 2, 3, 4, 5].map(i => (
                        <tr key={i}>
                          <td className="px-3"><div className="skeleton" style={{ height: '16px', width: '50px' }}></div></td>
                          <td className="px-3"><div className="skeleton" style={{ height: '16px', width: '80px' }}></div></td>
                          <td className="px-3"><div className="skeleton" style={{ height: '16px', width: '100px' }}></div></td>
                          <td className="px-3"><div className="skeleton" style={{ height: '16px', width: '70px' }}></div></td>
                          <td className="px-3"><div className="skeleton" style={{ height: '16px', width: '90px' }}></div></td>
                          <td className="px-3"><div className="skeleton" style={{ height: '16px', width: '60px' }}></div></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CoinDetailsSkeleton;